(function () {
  "use strict";

  function normalize(value) {
    return String(value || "").toLocaleLowerCase().replace(/\s+/g, " ").trim();
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function familyById(data, id) {
    return data.families.find(function (family) { return family.id === id; }) || data.families[0];
  }

  function categoryById(family, id) {
    return family.categories.find(function (category) { return category.id === id; }) || null;
  }

  function initDownloadCenter(root) {
    if (root.dataset.laDownloadReady === "true") return;
    root.dataset.laDownloadReady = "true";

    var indexUrl = root.dataset.indexUrl;
    var familyTabs = root.querySelector("[data-download-family-tabs]");
    var categoryNav = root.querySelector("[data-download-categories]");
    var search = root.querySelector("[data-download-search]");
    var heading = root.querySelector("[data-download-heading]");
    var resultCount = root.querySelector("[data-download-result-count]");
    var status = root.querySelector("[data-download-status]");
    var productList = root.querySelector("[data-download-products]");
    var empty = root.querySelector("[data-download-empty]");
    var productTotal = root.querySelector("[data-download-product-total]");
    var fileTotal = root.querySelector("[data-download-file-total]");
    var numberFormat = new Intl.NumberFormat("en-US");
    var data = null;
    var searchTimer = 0;
    var state = {
      family: normalize(location.hash.slice(1)) || "audio",
      category: "all",
      query: ""
    };

    function currentFamily() {
      return familyById(data, state.family);
    }

    function categoryLabel(product) {
      var family = familyById(data, product.family);
      var category = categoryById(family, product.category);
      return category ? category.label : product.productType;
    }

    function setFamily(familyId, updateHash) {
      state.family = familyById(data, familyId).id;
      state.category = "all";
      if (updateHash && history.replaceState) {
        history.replaceState(null, "", "#" + state.family);
      }
      renderFamilyTabs();
      renderCategories();
      renderProducts();
    }

    function renderFamilyTabs() {
      familyTabs.replaceChildren();
      data.families.forEach(function (family) {
        var button = element("button", "la-download-center__family-tab");
        button.type = "button";
        button.setAttribute("role", "tab");
        button.setAttribute("aria-selected", String(family.id === state.family));
        button.textContent = family.label + " (" + numberFormat.format(family.productCount) + ")";
        button.addEventListener("click", function () { setFamily(family.id, true); });
        familyTabs.appendChild(button);
      });
    }

    function categoryButton(id, label, productCount) {
      var button = element("button", "la-download-center__category");
      button.type = "button";
      button.dataset.category = id;
      button.setAttribute("aria-current", String(id === state.category));
      button.textContent = label + " (" + numberFormat.format(productCount) + ")";
      button.addEventListener("click", function () {
        state.category = id;
        renderCategories();
        renderProducts();
      });
      return button;
    }

    function renderCategories() {
      var family = currentFamily();
      categoryNav.replaceChildren();
      categoryNav.appendChild(categoryButton("all", "All " + family.label, family.productCount));
      family.categories.forEach(function (category) {
        categoryNav.appendChild(categoryButton(category.id, category.label, category.productCount));
      });
    }

    function matchesSearch(product) {
      if (!state.query) return true;
      var searchable = [product.title, product.productType, categoryLabel(product)];
      product.files.forEach(function (file) {
        searchable.push(file.label, file.extension);
      });
      return normalize(searchable.join(" ")).includes(state.query);
    }

    function filteredProducts() {
      return data.products.filter(function (product) {
        if (product.family !== state.family) return false;
        if (state.category !== "all" && product.category !== state.category) return false;
        return matchesSearch(product);
      });
    }

    function renderFiles(details, product) {
      if (details.dataset.filesReady === "true") return;
      details.dataset.filesReady = "true";
      var body = details.querySelector(".la-download-center__product-body");
      var files = element("div", "la-download-center__file-list");

      product.files.forEach(function (file) {
        var link = element("a", "la-download-center__file");
        link.href = file.url;
        link.target = "_blank";
        link.rel = "noopener";
        link.appendChild(element("span", "la-download-center__file-type", file.extension));
        link.appendChild(element("span", "la-download-center__file-name", file.label));
        link.appendChild(element("span", "la-download-center__file-action", "Open"));
        files.appendChild(link);
      });

      var productLink = element("a", "la-download-center__product-link", "View product");
      productLink.href = product.onlineStoreUrl;
      body.append(files, productLink);
    }

    function productRow(product) {
      var details = element("details", "la-download-center__product");
      var summary = element("summary", "la-download-center__product-summary");
      summary.appendChild(element("strong", "la-download-center__product-title", product.title));
      summary.appendChild(element("span", "la-download-center__product-category", categoryLabel(product)));
      summary.appendChild(element("span", "la-download-center__product-count", numberFormat.format(product.files.length) + (product.files.length === 1 ? " file" : " files")));
      var toggle = element("span", "la-download-center__product-toggle");
      toggle.setAttribute("aria-hidden", "true");
      summary.appendChild(toggle);
      details.append(summary, element("div", "la-download-center__product-body"));
      details.addEventListener("toggle", function () {
        if (details.open) renderFiles(details, product);
      });
      return details;
    }

    function renderProducts() {
      var family = currentFamily();
      var category = categoryById(family, state.category);
      var products = filteredProducts();
      var files = products.reduce(function (total, product) { return total + product.files.length; }, 0);
      heading.textContent = category ? category.label : family.label + " Files";
      resultCount.textContent = numberFormat.format(products.length) + " products / " + numberFormat.format(files) + " files";
      productList.replaceChildren();
      products.forEach(function (product) { productList.appendChild(productRow(product)); });
      productList.hidden = products.length === 0;
      empty.hidden = products.length !== 0;
    }

    search.addEventListener("input", function () {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        state.query = normalize(search.value);
        renderProducts();
      }, 120);
    });

    window.addEventListener("hashchange", function () {
      if (!data) return;
      var requested = normalize(location.hash.slice(1));
      if (data.families.some(function (family) { return family.id === requested; })) {
        setFamily(requested, false);
      }
    });

    fetch(indexUrl, { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("Download index request failed: " + response.status);
        return response.json();
      })
      .then(function (payload) {
        if (!payload || !Array.isArray(payload.families) || !Array.isArray(payload.products)) {
          throw new Error("Download index is invalid");
        }
        data = payload;
        state.family = familyById(data, state.family).id;
        productTotal.textContent = numberFormat.format(data.stats.products);
        fileTotal.textContent = numberFormat.format(data.stats.files);
        status.hidden = true;
        renderFamilyTabs();
        renderCategories();
        renderProducts();
      })
      .catch(function (error) {
        status.textContent = "Product files are temporarily unavailable.";
        root.dataset.downloadError = error.message;
      });
  }

  document.querySelectorAll("[data-la-download-center]").forEach(initDownloadCenter);
})();
